import "./Gallery.scss";

import { Box } from "@material-ui/core";
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import React, { useState } from "react";
import { SRLWrapper } from "simple-react-lightbox";

import { ActionButton } from "./ActionButton";

const options = {
  buttons: {
    backgroundColor: "#0059e2",
    iconPadding: "10px",
  },
  settings: { overlayColor: "rgb(105, 137, 150, 0.9)" },
};

const Gallery = ({
  className,
  elements,
}: any) => {
  const [offset, setOffset] = useState(0);

  const slideLeft = () => {
    setOffset((offset + 1) % elements.length);
  }

  const slideRight = () => {
    setOffset(offset !== 0 ? offset - 1 : elements.length - 1);
  }

  return (
    <SRLWrapper options={options}>
      <Box className="gallery-wrapper">
        <Box className={className + " gallery"} style={{ left: offset + "px" }}>
          {elements.map((
            elem: any, index: number
          ) => {
            const offsetIndex = (index + offset) % elements.length;
            const offsetElem = elements[offsetIndex];

            return (
              <img
                key={index}
                src={offsetElem.src}
                alt={offsetElem.alt}
                hidden={offsetElem.hidden}
                className={offsetElem.className}
              />
            );
          })}
        </Box>

        <ActionButton
          className="slide--left"
          onClick={slideLeft}
          icon={<KeyboardArrowLeftIcon />}
        />

        <ActionButton
          className="slide--right"
          onClick={slideRight}
          icon={<KeyboardArrowRightIcon />}
        />
      </Box>
    </SRLWrapper>
  );
};

export default Gallery;
